import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import React from 'react';
import { animationFrame, average, toRange } from "./view-audio-analyser.utils";
import '@isyc-react/design/main';
import "./view-audio-analyser.style.scss";
export const ViewAudioAnalyser = /*#__PURE__*/React.forwardRef((props, ref) => {
  const analyserViewIcon = React.useRef(null);
  const analyserViewCircle = React.useRef(null);
  React.useImperativeHandle(ref, () => ({
    analyse: (ctx, source) => {
      // Create an analyser
      const analyser = ctx.createAnalyser();
      analyser.fftSize = 32; // 256 // 2 ** 8
      const bufferLength = analyser.frequencyBinCount; // 256
      const dataArray = new Uint8Array(bufferLength);

      // Connect parts
      source.connect(analyser);
      analyser.connect(ctx.destination);

      // Visualisation
      const view = () => {
        analyser.getByteTimeDomainData(dataArray);
        const avg = average([...dataArray]);
        // make in range 0-1
        const maxFreq = 128;
        const avgParsed = (avg - 128) * 2.8125;
        const avgFiltered = Math.min(avgParsed, maxFreq);
        const v = toRange({
          value: avgFiltered,
          from: [0, maxFreq],
          to: [0, 1]
        });
        if (analyserViewIcon.current) analyserViewIcon.current.style.color = v === 0 ? '#6c757d' : 'var(--primary-color)';
        if (analyserViewCircle.current) analyserViewCircle.current.style.setProperty('--c', Math.abs(v).toString());
      };
      animationFrame(view, {
        fps: 20
      });
    }
  }), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "analyser-audio-container d-flex align-items-center justify-content-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-headphones font-size-52",
    ref: analyserViewIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: "analyser-audio-circle",
    ref: analyserViewCircle
  }))));
});